<div class="form container-fluid tagged-action-form">
  <div *ngIf="fillForm">
    <h1 mat-dialog-title class="mb-2 mt-2">Tagged Form</h1>
    <ng-template *ngIf="asyncData$ | async"> </ng-template>
    <ng-container *ngTemplateOutlet="taggedFormTemplate"></ng-container>
    <!-- <mat-tab-group #tabs mat-align-tabs="start">
      <mat-tab label="Tagged Actions">
        <ng-container *ngTemplateOutlet="taggedFormTemplate"></ng-container>
      </mat-tab>
    </mat-tab-group> -->
  </div>
  <div *ngIf="!fillForm">
    <mat-card>
      <ng-container *ngTemplateOutlet="taggedFormTemplate"></ng-container
    ></mat-card>
  </div>
</div>
<ng-template #taggedFormTemplate>
  <form [formGroup]="taggedAction">
    <div class="row">
      <div class="col-md-4">
        <mat-label class="ng-select-label required-field">Tagged To </mat-label
        ><br />

        <mat-button-toggle-group
          #group1="matButtonToggleGroup"
          [value]="selectedTagType"
          formControlName="taggedTo"
          aria-label="Tagged To"
          (change)="onChangeTaggedTo(group1.value)"
          multiple="false"
        >
          <mat-button-toggle aria-label="Employee" [value]="1"
            >Employee</mat-button-toggle
          >
          <mat-button-toggle aria-label="Self" [value]="0"
            >Self</mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>
      <div class="col-md-8" *ngIf="showTaggedEmp">
        <mat-label class="required-field"> Select Employee</mat-label>
        <dg-employee-search
          [class.disable-tree]="this.fillForm ? false : true"
          #empSearch1
          [empConfig]="empConfig1"
          [orgConfig]="orgConfig"
          [showFilter]="showFilter"
          [selectedEmployeeList]="selectedEmployeeList1"
          [isDisplayLoginEmp]="isDisplayLoginEmp"
          (change)="onChangeEmpTagged($event)"
          (output)="getDataEmpTagged($event)"
          [showEmpIdDsgnName]="true"
        >
        </dg-employee-search>
      </div>
    </div>
    <div class="row mt-2" *ngIf="showCC">
      <div class="col-md-4">
        <mat-label class="ng-select-label">CC </mat-label><br />

        <mat-button-toggle-group
          #group2="matButtonToggleGroup"
          [value]="selectedCCType"
          formControlName="ccTo"
          aria-label="CC"
          (change)="onChangeCC(group2.value)"
          multiple="false"
        >
          <mat-button-toggle aria-label="Employee" [value]="1"
            >Employee</mat-button-toggle
          >
          <mat-button-toggle aria-label="Group" [value]="2"
            >Group</mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>

      <div class="col-md-8" *ngIf="showBroadcastEmp">
        <mat-label class="required-field"> Select Employee</mat-label>
        <dg-employee-search
          [class.disable-tree]="this.fillForm ? false : true"
          #empSearch2
          [empConfig]="empConfig2"
          [orgConfig]="orgConfig"
          [showFilter]="showFilter"
          [selectedEmployeeList]="selectedEmployeeList2"
          [isDisplayLoginEmp]="isDisplayLoginEmp"
          (change)="onChangeEmpCC($event)"
          (output)="getDataEmpCC($event)"
          [showEmpIdDsgnName]="true"
        >
        </dg-employee-search>
      </div>
      <div class="col-md-8" *ngIf="showBroadcastGrp">
        <div class="ng-select-container form-group">
          <mat-label class="ng-select-label required-field"
            >Group Worktray
          </mat-label>
          <ng-select
            #subject
            [items]="worktrayList"
            bindLabel="optionText"
            placeholder="Group Worktray"
            formControlName="worktray"
            [multiple]="false"
            (change)="onChangeGroup($event)"
            appendTo="body"
          >
          </ng-select>
          <mat-error
            *ngIf="
              taggedAction?.controls?.worktray?.errors?.required &&
              taggedAction.controls.worktray?.touched
            "
          >
            Please select valid Group Worktray</mat-error
          >
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <mat-form-field>
        <mat-label class="required-field">Subject</mat-label>
        <textarea
          matInput
          rows="1"
          cols="300"
          [maxlength]="100"
          formControlName="subject"
        ></textarea>
        <mat-error>Please enter valid Subject</mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label class="required-field">Comments / Remarks</mat-label>
        <textarea
          matInput
          rows="4"
          cols="300"
          [maxlength]="1000"
          formControlName="comments"
        ></textarea>
        <mat-error>Please enter valid Comments</mat-error>
      </mat-form-field>
    </div>

    <div class="row mt-3" *ngIf="fillForm">
      <div class="col-md-12">
        <mat-label class="ng-select-label required-field"
          >Notification Type </mat-label
        ><br />

        <mat-button-toggle-group
          #group3="matButtonToggleGroup"
          [value]="selectedNotifTypes"
          formControlName="notifType"
          aria-label="Notification Type"
          (change)="onChangeNotifType(group3.value)"
          multiple="true"
        >
          <mat-button-toggle
            aria-label="Devices"
            [value]="111"
            checked
            [disabled]="true"
            ><mat-icon>devices</mat-icon></mat-button-toggle
          >
          <mat-button-toggle aria-label="SMS" [value]="113"
            ><mat-icon>sms</mat-icon></mat-button-toggle
          >

          <mat-button-toggle aria-label="Mail" [value]="112"
            ><mat-icon>mail</mat-icon></mat-button-toggle
          >
          <!-- <mat-button-toggle value="whatsapp">Whatsapp</mat-button-toggle> -->
        </mat-button-toggle-group>
      </div>
      <!-- <div class="col-md-12 mt-2">
        <mat-form-field>
          <mat-label class="required-field">Description / Message</mat-label>
          <textarea
            matInput
            rows="2"
            cols="300"
            formControlName="desc"
          ></textarea>
          <mat-error>Please enter valid Description</mat-error>
        </mat-form-field>
      </div> -->
    </div>
    <div class="row" *ngIf="fillForm">
      <div class="col-md-12">
        <mat-label class="ng-select-label">Reminders Repeat </mat-label><br />

        <mat-button-toggle-group
          #group4="matButtonToggleGroup"
          [value]="selectedRepeat"
          formControlName="remRepeat"
          aria-label="Remider Repeat"
          (change)="onChangeRepeat(group4.value)"
          multiple="false"
        >
          <mat-button-toggle aria-label="Yes" [value]="11"
            >Yes</mat-button-toggle
          >
          <mat-button-toggle aria-label="No" [value]="12">No</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="col-md-12" *ngIf="repeatYes">
        <div class="row mt-2">
          <div class="col-md-4">
            <mat-form-field>
              <mat-label class="required-field">Start On</mat-label>
              <input
                matInput
                readonly
                [ngxMatDatetimePicker]="ntfc_start_time"
                formControlName="startOn"
                [min]="today"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="ntfc_start_time"
              ></mat-datepicker-toggle>

              <ngx-mat-datetime-picker
                [defaultTime]="defaultStartTime"
                [hideTime]="false"
                [showSeconds]="false"
                #ntfc_start_time
              >
              </ngx-mat-datetime-picker>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field>
              <mat-label class="">Until</mat-label>
              <input
                matInput
                readonly
                [ngxMatDatetimePicker]="ntfc_end_time"
                formControlName="until"
                [min]="
                  setMinDateForPickerAccStartDate
                    | func: taggedAction?.controls?.startOn?.value
                "
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="ntfc_end_time"
              ></mat-datepicker-toggle>

              <ngx-mat-datetime-picker
                [defaultTime]="defaultStartTime"
                [hideTime]="false"
                [showSeconds]="false"
                #ntfc_end_time
              >
              </ngx-mat-datetime-picker>
              <mat-error
                *ngIf="taggedAction?.controls?.until?.errors?.timeError"
              >
                End time should be greater than start time</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field>
              <mat-label class="required-field">Repeat Every</mat-label>
              <input
                type="number"
                matInput
                required
                min="1"
                max="10"
                formControlName="repeatEvery"
                class="me-2"
                oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
              />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-label></mat-label>
            <ng-select
              class="mt-3"
              [items]="repeatValues"
              appendTo="body"
              bindLabel="optionText"
              bindValue="optionValue"
              formControlName="optionSelect"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="repeatNo">
        <mat-form-field>
          <mat-label class="required-field">Reminds On</mat-label>
          <input
            matInput
            [ngxMatDatetimePicker]="reminds_on_start_time"
            formControlName="remindsOn"
            [min]="today"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="reminds_on_start_time"
          ></mat-datepicker-toggle>

          <ngx-mat-datetime-picker
            [defaultTime]="defaultStartTime"
            [hideTime]="false"
            [showSeconds]="false"
            #reminds_on_start_time
          >
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="showattachment">
      <div *ngIf="this.showattachment && !this.isAllowDelete">
        Attachments :
      </div>
      <div class="col-md-12">
        <dg-file-upload
          #dgFileUpload
          [multiple]="multipleAllowed"
          [edit]="isEdit"
          [acceptedType]="appAcceptedType"
          [attachId]="appAttachID"
          [maxSize]="appMaxSize"
          [maxfiles]="appMaxFiles"
          (finalPath)="onFinalPath($event)"
          [title]="attachmentTitle"
          [uniqueAttachmentId]="attachmentID"
          [allowUpdate]="isAllowUpdate"
          [allowFileToAttach]="isAllowFileToAttach"
          [allowDelete]="isAllowDelete"
          [mandatory]="isMandatory"
          [attachSmall]="attachSmall"
          [refreshAttachComponent]="isRefresh"
          [isDownload]="true"
        >
        </dg-file-upload>
      </div>
    </div>
    <div class="mt-3" *ngIf="fillForm">
      <button
        color="primary"
        mat-raised-button
        (click)="onSubmit()"
        [disabled]="taggedAction.invalid"
      >
        Submit
      </button>
      <button mat-raised-button (click)="onReset()" class="mx-2">Reset</button>
      <button mat-raised-button [mat-dialog-close]="true" class="">
        Close
      </button>
    </div>
  </form>
</ng-template>
